/* @flow */

import {
  buildVirtualBraindateNotification,
  buildVirtualBraindateEarlyReminder,
} from 'plugin/virtual-braindate/util/virtualBraindateUtils';
import { queueNotification } from 'src/shared/app/notification/action/uiNotificationActions';

import type { Braindate } from '@e180/domain/lib/braindate/type';

export function showVirtualBraindateEarlyReminder(braindate: Braindate) {
  return queueNotification(
    buildVirtualBraindateEarlyReminder((braindate: Braindate)),
  );
}

export function showVirtualBraindateNotification(braindate: Braindate) {
  return queueNotification(
    buildVirtualBraindateNotification((braindate: Braindate)),
  );
}
